import { observer } from 'mobx-react';
import * as React from 'react';
import ParticipantsStore from '../../../../../ParticipantsStore';
import SelectAll from './SelectAll';
import DeselectAll from './DeselectAll';
import { CheckedParticipantsState } from '../../../../../ParticipantsStore/Types';

interface Props {
  participantsStore: ParticipantsStore;
}

const CheckboxControls: React.FC<Props> = ({ participantsStore }) => {
  const checkedParticipantsState = (): CheckedParticipantsState => {
    if (participantsStore.participantStores.every((p) => p.participantChecked === true))
      return 'all-checked';
    if (participantsStore.participantStores.every((p) => p.participantChecked === false))
      return 'none-checked';
    return 'some-checked';
  };

  switch (checkedParticipantsState()) {
    case 'none-checked':
      return (
        <div className="flex">
          <SelectAll participantsStore={participantsStore} />
        </div>
      );
    case 'all-checked':
      return (
        <div className="flex">
          <DeselectAll participantsStore={participantsStore} />
        </div>
      );
    case 'some-checked':
      return (
        <div className="flex">
          <DeselectAll participantsStore={participantsStore} />
          <SelectAll participantsStore={participantsStore} />
        </div>
      );
  }
};
export default observer(CheckboxControls);
